
import useScrollAnimation from '../../../hooks/useScrollAnimation';

const FeaturesSection = () => {
  const { ref: sectionRef, isVisible } = useScrollAnimation({ threshold: 0.1 });

  const features = [
    {
      icon: 'ri-money-euro-circle-fill',
      title: 'Pago Inmediato',
      description: 'Recibe el dinero al momento de la recogida. Sin esperas ni trámites bancarios. Efectivo o transferencia instantánea.',
    },
    {
      icon: 'ri-file-text-fill',
      title: 'Gestión Completa',
      description: 'Nos encargamos de toda la documentación: baja de tráfico, certificado de destrucción y trámites administrativos.',
    },
    {
      icon: 'ri-map-pin-user-fill',
      title: 'Recogida Gratis',
      description: 'Recogemos tu vehículo donde esté en Gavá, Castelldefels, Viladecans y toda la comarca. Grúa 100% gratuita.',
    },
  ];

  return (
    <section ref={sectionRef} className="py-12 sm:py-24 px-4 sm:px-6 lg:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        <div 
          className={`flex flex-col lg:flex-row justify-between items-start mb-8 sm:mb-16 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 lg:mb-0">
            Por Qué Elegir Nuestro<br /><strong>Desguace en Gavá</strong>
          </h2>
          <p className="text-sm sm:text-lg text-gray-600 max-w-md leading-relaxed">
            Más de <strong>15 años de experiencia</strong> en el sector del desguace en Gavá. Profesionalidad, rapidez y las mejores valoraciones.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`bg-gray-50 rounded-xl p-6 sm:p-10 hover:shadow-lg transition-all hover:-translate-y-1 cursor-pointer duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
              style={{ transitionDelay: isVisible ? `${(index + 1) * 150}ms` : '0ms' }}
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-emerald-600 rounded-full flex items-center justify-center mb-4 sm:mb-6 mx-auto">
                <i className={`${feature.icon} text-white text-xl sm:text-2xl`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-4 text-center">
                <strong>{feature.title}</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed text-center text-xs sm:text-base">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
